module.exports = __webpack_public_path__ + "img/logo-tick-xanh.acdccf70.png";